// @flow
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import type { TPlayerWithFixture } from '../../modules/types/player';

import {
	ModalContainer,
	CoachLockIcon,
} from '../../components';
import colors from "../../assets/css/colors";
import Broncos from "../../assets/images/teamSilhouettes/broncos-silhouette.svg";
import Bulldogs from "../../assets/images/teamSilhouettes/bulldogs-silhouette.svg";
import Cowboys from "../../assets/images/teamSilhouettes/cowboys-silhouette.svg";
import Dragons from "../../assets/images/teamSilhouettes/dragons-silhouette.svg";
import Eels from "../../assets/images/teamSilhouettes/eels-silhouette.svg";
import Knights from "../../assets/images/teamSilhouettes/knights-silhouette.svg";
import Panthers from "../../assets/images/teamSilhouettes/panthers-silhouette.svg";
import Rabbitohs from "../../assets/images/teamSilhouettes/rabbitohs-silhouette.svg";
import Raiders from "../../assets/images/teamSilhouettes/raiders-silhouette.svg";
import Roosters from "../../assets/images/teamSilhouettes/roosters-silhouette.svg";
import SeaEagles from "../../assets/images/teamSilhouettes/sea-eagles-silhouette.svg";
import Sharks from "../../assets/images/teamSilhouettes/sharks-silhouette.svg";
import Storm from "../../assets/images/teamSilhouettes/storm-silhouette.svg";
import Titans from "../../assets/images/teamSilhouettes/titans-silhouette.svg";
import Warriors from "../../assets/images/teamSilhouettes/warriors-silhouette.svg";
import Tigers from "../../assets/images/teamSilhouettes/wests-tigers-silhouette.svg";
import Dolphins from "../../assets/images/teamSilhouettes/dolphins-silhouette.svg";
import * as selectors from "../../modules/selectors";
import BorderedIcon from "../../components/BorderedIcon";
import Star from '../../components/Icons/Star';
import { below } from '../../assets/css/media';
import * as actions from "../../modules/actions";

const TopPopupBlock = styled.div`
	// Brisbane Broncos
	&.squad-500011{
		background: #6c1d45;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Broncos}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Canterbury-Bankstown Bulldogs
	&.squad-500010{
		background: #00468b;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Bulldogs}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// North Queensland Cowboys
	&.squad-500012{
		background: #0c2340;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Cowboys}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// St George-Illawarra Dragons
	&.squad-500022{
		background: #cd232c;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Dragons}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Parramatta Eels
	&.squad-500031{
		background: #002d72;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Eels}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Newcastle Knights
	&.squad-500003{
		background: #003b73;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Knights}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Penrith Panthers
	&.squad-500014{
		background: #2c2f30;&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Panthers}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// South Sydney Rabbitohs
	&.squad-500005{
		background: #003b19;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Rabbitohs}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Canberra Raiders
	&.squad-500013{
		background: #009a4d;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Raiders}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Sydney Roosters
	&.squad-500001{
		background: #0b2d5b;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Roosters}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Manly-Warringah Sea Eagles
	&.squad-500002{
		background: #660238;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${SeaEagles}) !important;
	background-repeat: no-repeat !important;
	background-size: 148% 100% !important;
	}
	}


	// Cronulla-Sutherland Sharks
	&.squad-500028{
		background: #1f7eb2;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Sharks}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Melbourne Storm
	&.squad-500021{
		background: #491f6b;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Storm}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Wests Tigers
	&.squad-500023{
		background: #262626;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Tigers}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// Gold Coast Titans
	&.squad-500004{
		background: #005e9b;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Titans}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}


	// New Zealand Warriors
	&.squad-500032{
		background: #2a2e34;
		&:after{
	content: ' ';
    display: block;
    position: absolute;
    left: 0;
    top: -232px;
    width: 100%;
    height: 613px;
    z-index: 1;
    opacity: 0.1;
	background-image: url(${Warriors}) !important;
	background-repeat: no-repeat !important;
	background-size: 110% 100% !important;
	}
	}

	&.squad-500723 {	
		background: #fc141d;
		&:after{
			content: ' ';
			display: block;
			position: absolute;
			left: 0;
			top: -232px;
			width: 100%;
			height: 613px;
			z-index: 1;
			opacity: 0.1;
			background-image: url(${Dolphins}) !important;
			background-repeat: no-repeat !important;
			background-size: 110% 100% !important;
		}
	}
	display: flex;
	flex-direction: column;
	height: 376px;
	width: 100%;
	padding-top: 64px;
	position: relative;
	overflow: hidden;

	> div {
		z-index: 2;
		&.povered-by{
			display: flex;
			justify-content: flex-end;
			padding: 20px 20px 0 0;
			${below.desktop`
					display:none;
			`}
		}
	}

	${below.desktop`
		height:244px;
		padding-top: 0px;
	`}


`;

const PlayerInfoBlock = styled.div`
	display: flex;
	justify-content: space-around;

	${below.desktop`
		justify-content: flex-start;
	`}
`;

const PlayerInfoDescription = styled.div`
	${below.desktop`
		padding-left: 1em;
		padding-top: 1em;
		min-width: 160px;
	`}
`;

const PlayerAvatar = styled.div`
	margin-top: -64px;
	margin-right: 5em;

	> img {
		max-height: 376px;
		${below.desktop`
			height:244px;
		`}
	}

	${below.desktop`
		margin-top: 0;
		margin-right: 0;
		margin-left: auto;
	`}
`;

const BottomPopupBlock = styled.div`
	height: 190px;
	display: flex;
	flex-direction: column;
	background: white;
	 ${below.desktop`
	 	height: 220px;
	 `}

`;


const PlayerStar = styled.div`
	margin-bottom: 15px;
`;


const PlayerInfoName = styled.div`
	display: flex;
	flex-direction: column;
	align-items: baseline;
	color: white;
	> p {
		font-size: 36px;
		font-weight: 900;
		line-height: 1.22;
		${below.desktop`
			font-size: 16px;
		`}
	}
`;

const BorderedIconStyeld = styled(BorderedIcon)`
	width: 50px;
	height: 50px;
	color:green;
	${below.desktop`
		width: 40px;
		height: 40px;
	`}

`;

const PlayerTeamOppositionBlock = styled.div`
	display: flex;
	flex-direction: column;
	color: white;
	font-size: 18px;
	font-weight: bold;
	line-height: 1.5;
	p{
		text-align: left;
	}
	${below.desktop`
		font-size: 12px;
		margin: 1em 0 1.5em 0;
	`}

`;

const PlayerPopupButtons = styled.div`
	display:flex;
	justify-content: flex-start;
	margin-top: 1.5em;
`;

const FullPlayerProfileButton = styled.a`
	width: 200px;
	height: 36px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #FFF;
	border-radius: 3px;
	text-transform: uppercase;
	font-size: 12px;
	font-weight: bold;
	color: #FFF;
	text-decoration: none;

	${below.desktop`
		width: auto;
		padding: 0 10px;
		white-space: nowrap;
	`}
`;

// const TradeButton = styled.div`
// 	cursor: pointer;
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	height: 50px;
// 	width: 50px;
// 	background: white;
// 	border-radius:3px;
// 	font-size: 10px;
// 	font-size:20px;
// 	font-weight: bold;
// 	color:${colors.nrlDarkGreen};
// 		${below.desktop`
// 			font-size:16px;
// 			height: 40px;
// 			width: 40px;
// 		`}
// `;
//
// const FaButton = styled.div`
// 	font-size: 20px;
// 	cursor: pointer;
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	height: 50px;
// 	width: 50px;
// 	display: flex;
// 	background: ${colors.lightGrey};
// 	border-radius:3px;
// 	font-size: 10px;
// 	font-weight: bold;
// 	margin-left: 0.3em;
// 	color: ${colors.toggle_background};
// 		${below.desktop`
// 			height: 40px;
// 			width: 40px;
// 			font-size:16px;
// 		`}
//
// `;

const TopStats = styled.div`
	display: flex;
`;

const BottomStats = styled.div`
	display: flex;
	border-bottom: 10px solid ${colors.active_stats};
`;

const StatItem = styled.div`
	width:25%;
	height: 90px;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	${below.desktop`
		border-right: 1px solid ${colors.active_stats};
		border-bottom: 1px solid ${colors.active_stats};
		height:110px;
	`}
`;

const StatHeader = styled.div`
	font-size: 12px;
	line-height: 1.5;
	color:${colors.title};
	letter-spacing: 0.5px;
	height: 18px;
	&.coach-val{
		color:${colors.coach_value};
	}
	${below.desktop`
		font-size: 10px;
		width: 65px;
		letter-spacing: 0.42px;
		text-align:center;
		height: auto;
	`}


`;
const StatValue = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 26px;
	line-height: 1.2;
	font-weight: 900;
	height: 31px;
	&.positive{
		color:${colors.nrlDarkGreen};
	}
	&.negative{
		color:${colors.negative_value};
	}
	&.lock-val{
		font-size: 20px;
	}

	&.coach-val{
		color:${colors.coach_value};
	}

	${below.desktop`
		font-size: 20px;
		height: 29px;
		width:48px;
	`}

`;

const PopupWrapper = styled.div`
	.modal-body{
		max-height: 568px;
		height: 90vh;
		${below.desktop`
			overflow-x: hidden;
			max-height: 80vh;

		`}
		${below.tablet`
			max-height: 80vh;
			height: auto;
		`}

		${below.phone`
			overflow: hidden;
			max-height: 90vh;
			height: auto;
		`}
	}
`;


type Props = {
	closeClick: Function,
	postAddToFavourites: Function,
	postRemoveFromFavourites: Function,
	player?: TPlayerWithFixture,
	actual_round: Object,
	has_assistant_coach: Boolean,
	rounds: Array<Object>
};

class PlayerProfilePopupComponent extends React.Component<Props> {

	constructor(props, state) {
		super(props, state);

		_.bindAll(this, [
			'toggleFav',
		]);
	}

	toggleFav(player) {
		const { postAddToFavourites, postRemoveFromFavourites } = this.props;

		if (player.is_favourite) {
			postRemoveFromFavourites(player.id);
		}
		else {
			postAddToFavourites(player.id);
		}
	}

	get stat_title() {
		const ENV_YEAR = process.env.REACT_APP_CURRENT_YEAR || "2026";
		const firstRoundCompleted = this.props.rounds.find(round => round.status === 'complete');
		const
			{ player, actual_round, has_assistant_coach } = this.props,
			getPlayerField = _.partial(_.get, player, _, '--'),
			getByCondition = (predicate, onTrue, onFalse) => predicate ? onTrue : onFalse,
			avg_points = _.get(player, 'stats.avg_points', 0),
			tog = _.get(player, 'stats.tog', 0),
			// $FlowFixMe: Flow doesn't understand Math.round10, even when we have add polyfill.
			ppm = Math.round10(_.divide(avg_points, tog), -2),
			is_first_round = _.eq(actual_round.id, 1),
			is_round_scheduled = _.eq(actual_round.status, 'scheduled'),
			is_preseason = [is_first_round, is_round_scheduled].every(_.identity),
			current_year = new Date().getFullYear(),
			yearUsed = (current_year === parseInt(ENV_YEAR, 10) && firstRoundCompleted) ? parseInt(current_year, 10) : parseInt(ENV_YEAR, 10) - 1,
			//year = getByCondition(is_preseason, yearUsed, yearUsed),
			proj_scores = getByCondition(
				is_preseason,
				getPlayerField('stats.proj_scores.1'),
				getPlayerField('stats.proj_score_actual_round'),
			),
			proj_avg_or_last_three_mins = getByCondition(
				is_preseason,
				getPlayerField('stats.proj_avg'),
				getPlayerField('stats.last_3_tog_avg'),
			),
			last_three_avg = getPlayerField('stats.last_3_avg');

		return (
			<BottomPopupBlock>
				<TopStats>
					<StatItem>
						<StatHeader>
							{yearUsed} Avg
						</StatHeader>
						<StatValue>
							{getPlayerField('stats.avg_points')}
						</StatValue>
					</StatItem>
					<StatItem>
						<StatHeader>
							{yearUsed} Avg Mins
						</StatHeader>
						<StatValue>
							{getPlayerField('stats.tog')}
						</StatValue>
					</StatItem>
					<StatItem>
						<StatHeader>
							{yearUsed} Games Played
						</StatHeader>
						<StatValue>
							{getPlayerField('stats.games_played')}
						</StatValue>
					</StatItem>
					<StatItem>
						<StatHeader>
							{yearUsed} Points Per Minute
						</StatHeader>
						<StatValue>
							{_.isNaN(ppm) ? '--' : ppm}
						</StatValue>
					</StatItem>
				</TopStats>
				<BottomStats>
					<StatItem>
						<StatHeader className="coach-val">
							{yearUsed} Last 3 Avg
						</StatHeader>
						<StatValue className="coach-val">
							{last_three_avg}
						</StatValue>
					</StatItem>
					<StatItem>
						<StatHeader className="coach-val">
							{yearUsed} Owned %
						</StatHeader>
						<StatValue className="coach-val">
							{getByCondition(
								has_assistant_coach,
								`${getPlayerField('stats.draft_owned_by')}%`,
								<CoachLockIcon />,
							)}
						</StatValue>
					</StatItem>
					<StatItem>
						<StatHeader className="coach-val">
							{getByCondition(
								is_preseason,
								`${yearUsed.toString()} Rd ${actual_round.id} Proj`,
								`${yearUsed.toString()} Next Rd Proj`,
							)}
						</StatHeader>
						<StatValue className="coach-val">
							{getByCondition(has_assistant_coach, proj_scores, <CoachLockIcon />)}
						</StatValue>
					</StatItem>
					<StatItem>
						<StatHeader className="coach-val">
							{getByCondition(
								is_preseason,
								`${yearUsed.toString()} Proj Avg`,
								`${yearUsed.toString()} Last 3 Average Mins`,
							)}
						</StatHeader>
						<StatValue className="coach-val">
							{getByCondition(
								has_assistant_coach,
								proj_avg_or_last_three_mins,
								<CoachLockIcon />,
							)}
						</StatValue>
					</StatItem>
				</BottomStats>
			</BottomPopupBlock>);
	}

	render() {
		const { player } = this.props;

		if (!player) {
			return null;
		}

		const PLAYERS_AVATAR_PATH = (process.env.REACT_APP_PLAYERS_PATH || '');

		return (
			<PopupWrapper>
				<ModalContainer onClick={this.props.closeClick}>
					<TopPopupBlock className={`squad-${_.get(player, 'squad.id')}`}>
						<PlayerInfoBlock>
							<PlayerInfoDescription>
								<PlayerStar>
									<BorderedIconStyeld
										background={'white'}
										hover={colors.lightGreen}
									>

										<Star active={player.is_favourite}
											onClick={() => this.toggleFav(player)}
											isFavourite={player.is_favourite}
											color={player.is_favourite ? '#F6DE14' : '#000'}
											width={'26px'}
											height={'26px'}
										/>

									</BorderedIconStyeld>
								</PlayerStar>
								<PlayerInfoName>
									<p>{_.get(player, 'first_name')}</p>
									<p>{_.get(player, 'last_name')}</p>
								</PlayerInfoName>
								<PlayerTeamOppositionBlock>
									<p>
										{_.get(player, 'squad.short_name')}
										{' | '}
										{_.get(player, 'positions_name')}
									</p>
									<p>
										Next
										{' '}
										{_.get(player, 'competition.symbol')}
										{' '}
										{_.get(player, 'competition.opponent.short_name')}
									</p>
								</PlayerTeamOppositionBlock>
								<PlayerPopupButtons>
									<FullPlayerProfileButton
										href={`/player-profile/${player.id}`}
										target="_blank"
									>
										Full Player Profile
									</FullPlayerProfileButton>
								</PlayerPopupButtons>
							</PlayerInfoDescription>
							<PlayerAvatar>
								<img
									src={`${PLAYERS_AVATAR_PATH + player.id}.png`}
									alt=""
								/>
							</PlayerAvatar>
						</PlayerInfoBlock>
					</TopPopupBlock>

					{this.stat_title}

				</ModalContainer>
			</PopupWrapper>
		);
	}
};

const mapDispatchToProps = {
	postAddToFavourites: actions.players.postAddToFavourites,
	postRemoveFromFavourites: actions.players.postRemoveFromFavourites,
};

const mapStateToProps = state => ({
	actual_round: selectors.rounds.getActualRound(state),
	has_assistant_coach: Boolean(selectors.getUser(state).assistant_coach),
	rounds: selectors.rounds.getRounds(state)
});

export const PlayerProfilePopup = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps,
	)(PlayerProfilePopupComponent),
);

export default PlayerProfilePopup;


// WEBPACK FOOTER //
// ./src/components/PlayerProfilePopup/index.js